;
define("pickup_in_store_store_selector.tpl", function(){});

